import { useFallbackStorageValue } from "./fallback-storage-value";

export const useSubscriptionsList = () => {
  const { set: setSubscriptionList, value: subscriptionList } =
    useFallbackStorageValue<string[]>("subscriptedList");

  return { setSubscriptionList, subscriptionList };
};
